import api from "./instance";

export const getBanners = () => api.get("/staff/getbanners");

export const getAllCategories = () => api.get("/admin/getallcategory");

export const getSpecialCategories = () => api.get("/staff/getspecialcategory");
export const getLabTests = () => api.get("/staff/gettests");

export const getScans = () => api.get("/staff/getscans");

export const getStaffTestPackages = () => api.get("/staff/stafftestpackages");
